
import getLangRoute from '~/utils/getCurrentRoute'

export default {
  data() {
    return {
      toggled: false,
    }
  },
  mounted() {
    this.toggled = this.$store?.state?.language === 'zh-cn'
  },
  methods: {
    // getLangLabel() {
    //   return this.$store.state.language === 'zh-cn' ? 'EN' : '中文'
    // },
    updateLang() {
      const lang = this.$store.state.language !== 'zh-cn' ? 'zh-cn' : 'en'

      if (this.$store.state.language === lang) {
        return null
      }

      const [, path] = getLangRoute(this.$route)

      this.$store.commit('setLanguage', lang)
      this.$store.dispatch('loadData', { lang, path })
      const newPath = this.buildNewLangPath(lang)

      if (newPath !== null) {
        this.$router.push({
          path: newPath,
          force: true,
        })
      }
    },
    toggleHandler() {
      this.toggled = !this.toggled
      this.updateLang()
    },
    buildNewLangPath(lang) {
      const fullPath = this.$route.fullPath

      // remove any lang from url and serve default for english
      if (lang === 'en') {
        const stripLang = fullPath.split('/')
        return fullPath.split(stripLang[1])[1]
      } else {
        // append new lang to url
        return '/' + lang + this.$route.fullPath
      }
    },
  },
}
